import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import moment from 'moment'
import axios from 'axios'
import ProductDetails from './productDetails'

const classPrefix = 'widget_session_booking_calendar'

const Slot = ({start, end, duration, slotsDurationshow}) => {
   const getDuration = () => {
      if (!slotsDurationshow) {
         return ''
      }
      if(duration < 3600){
         return (<span>{_.round(duration / 60, 2)}min</span>)
      }
      const leftSeconds = duration % 3600
      const hours = (duration - leftSeconds) / 3600
      if (leftSeconds == 0){
         return (<span>{hours}h</span>)
      }
      return (<span>{hours}h {_.round(leftSeconds / 60, 2)}min</span>)
   }
   return (
      <>
         {start + ' - ' + end} {getDuration()}
      </>
   )
 }
 
 
 const Calendar = ({t, expert, query, product, scope, config}) => {
 
   const [selectedDate, setSelectedDate] = useState(null)
   const [selectedSlot, setSelectedSlot] = useState(null)
   
   const [holdMonth, setHoldMonth] = useState(null)
   const [holdYear, setHoldYear] = useState(null)
   const [currentMonth, setCurrentMonth] = useState(null)
   const [currentYear, setCurrentYear] = useState(null)
   const [availabilities, setAvailabilities] = useState([])
   const [slotExpand, setSlotExpand] = useState(false)

   const slotsDisplay = _.get(config, 'slots_display', 'list')
   const slotsDurationshow = _.get(config, 'slots_duration_show', true)
   const slotsSplit = _.get(config, 'slots_split', false)

 
   const getCurrentDate = () => {
      return moment(currentYear+'-'+_.padStart(currentMonth, 2, '0')+'-01 00:00:00')
   }
 
   const getCurrentDateStart = () => {
      const currentDate = getCurrentDate()
      return currentDate.startOf('month').format('YYYY-MM-DD')
   }
 
   const getCurrentDateEnd = () => {
      const currentDate = getCurrentDate()
      return currentDate.add(1, 'months').startOf('month').subtract(1, 'days').format('YYYY-MM-DD')
   }
 
   const getDates = () => {
      const getAvailabilities = () => {
         return availabilities.map((item) => {
            return moment.unix(item.start).format('Y-MM-DD')
         })
      }
      return _.uniq(getAvailabilities())
   }

   const getHourFormat = (date) => {
      if(t.getLang() == 'fr') {
         return date.format('HH[h]mm')
      }
      if(t.getLang() == 'en') {
         return date.format('h:mm A')
      }
      return date.format('HH[h]mm')
   }
 
   const nextMonth = () => {
      const currentDate = getCurrentDate()
      currentDate.add(1, 'months')
      setCurrentMonth(currentDate.format('M'))
      setCurrentYear(currentDate.format('YYYY'))
   }
 
   const prevMonth = () => {
      const currentDate = getCurrentDate()
      currentDate.subtract(1, 'months')
      setCurrentMonth(currentDate.format('M'))
      setCurrentYear(currentDate.format('YYYY'))
   }
 
   useEffect(() => {
      setCurrentMonth(moment().format('M'))
      setCurrentYear(moment().format('YYYY'))
      setHoldMonth(moment().format('M'))
      setHoldYear(moment().format('YYYY'))
   }, [])

   const isHoldPeriod = () => {
      if(!holdMonth || !holdYear) {
         return false
      }
      return holdMonth == currentMonth && holdYear == currentYear
   }
 
   useEffect(() => {
      if(currentMonth && currentYear) {
         const startDate = getCurrentDateStart()
         const endDate = getCurrentDateEnd()
         axios('/expert/' + _.get(expert, 'slug') + '/availabilities?start=' + getCurrentDateStart() + '&end=' + getCurrentDateEnd() + '&product=' + product.id).then((res) => {
            const {data} = res
            if(data && data.results && data.results.length > 0) {
               setAvailabilities(data.results)
            } else {
               if(isHoldPeriod()) {
                  nextMonth()
               }
            }
         }).catch((e) => {
         })
      }
    }, [currentMonth, currentYear])

   const unselectAll = () => {
      setSelectedDate(null)
      setSelectedSlot(null)
   }
 
   const getHeader = () => {
      if(selectedDate) {
         return (
            <div className={'head'}>
               <div className="back" onClick={() => unselectAll()}>
                  <i className="fa-solid fa-chevron-left"></i>
               </div>
               <div className="title">{getSelectedDateFormatted()}</div>
            </div>
         )
      }
      return null
      return (
         <div className={'head'}>
            <div className="title">Booker {_.get(expert, 'firstname')}</div>
            <p>Choississez une date qui vous correspond pour profiter d’une entrevue</p>
         </div>
      )
   }

   const getSelectedDateFormatted = () => {
      if(!selectedDate) {
         return ''
      }
      const date = moment(selectedDate)
      const day = date.format('D')
      const month = t.getMonths()[date.format('M') - 1]
      const year = date.format('YYYY')
      return `${day} ${month} ${year}`
   }

   const getDayShort = (day) => {
      const dayLower = day.toLowerCase()
      return dayLower.slice(0, 3)
   }

   const getDaysNames = () => {
      const weekSeq = t.getDays()
      return weekSeq.map((day, index) => {
         return (
            <div key={index} className="day_name">
               {getDayShort(day)}
            </div>
         )
      })
   }
 
    const getDays = (days) => {
       const weeks = _.chunk(days, 7)
       const getWeek = (week) => {
          return week.map(({available, date, day, index, current_month}) => {
             const dayClass = ['day']
             if(available){
                dayClass.push('available')
             }
             if(!current_month){
               dayClass.push('out_of_month')
             }
             const handleClick = () => {
               if (available) {
                  setSelectedDate(date)
               }
             }
             return (
                <div key={index} className={dayClass.join(' ')} onClick={() => handleClick()}>
                   <span>{day == 0 ? '' : day}</span>
                </div>
             )
          })
       }
       return weeks.map((week, weekIndex) => {
          return (
             <div key={weekIndex} className="week">
                {getWeek(week)}
             </div>
          )
       })
    }
 
   const getWeeks = () => {
 
      const dates = getDates()
      const weekSeq = ['L','M','M','J','V','S','D']
 
      const currentDate = getCurrentDate()
      const currentDateStart = getCurrentDateStart()
      const currentDateEnd = getCurrentDateEnd()

      const daysInMonth = currentDate.daysInMonth()
      const dayOfMonthStart = currentDate.format('E')

      let days = []
      let index = 0
      
      if(dayOfMonthStart > 0){
         let i = 0
         const lastDayPrevMonth = moment(currentDateStart).subtract(1, 'days').format('D')
         while(i < (dayOfMonthStart - 1)) {
            const prevDate = moment(currentDateStart).subtract((dayOfMonthStart - 1 - i), 'days')
            days.push({
               //name: weekSeq[i],
               name: weekSeq[prevDate.format('E') - 1],
               day: prevDate.format('D'),
               date: prevDate.format('YYYY-MM-DD'),
               available: false,
               current_month: false,
               index
            })
            i++
            index++
         }
      }
 
      let i = 0
      while(i < daysInMonth) {
         days.push({
            name: weekSeq[currentDate.format('E') - 1],
            day: currentDate.format('D'),
            date: currentDate.format('YYYY-MM-DD'),
            available: _.includes(dates, currentDate.format('YYYY-MM-DD')) ? true : false,
            current_month: true,
            index
         })
         currentDate.add(1, 'days')
         i++
         index++
      }
        
      let nexti = 1
      while(days.length % 7 != 0) {
         const nextDate = moment(currentDateEnd).add(nexti, 'days')
         days.push({
            name: weekSeq[nextDate.format('E') - 1],
            day: nextDate.format('D'),
            date: nextDate.format('YYYY-MM-DD'),
            available: false,
            current_month: false,
            index
         })
         nexti++
         index++
      }

      return (
         <>
            <div className={`${classPrefix}_days_names`}>
               {getDaysNames()}
            </div>
            <div className={`${classPrefix}_weeks`}>
               {getDays(days)}
            </div>
         </>
      )
 
   }
 
    const getPrevMonth = () => {
       return (
          <div className="prev" onClick={() => prevMonth()}>
             <i className="fa-solid fa-chevron-left"></i>
          </div>
       )
    }
 
    const getNextMonth = () => {
       return (
          <div className="next" onClick={() => nextMonth()}>
             <i className="fa-solid fa-chevron-right"></i>
          </div>
       )
    }
 
    const getNameMonth = () => {
       const monthsNames = t.getMonths()
       return (
          <div className={`${classPrefix}_month_name`}>
             {monthsNames[currentMonth - 1]}
          </div>
       )
    }
 
    const getSlotsComponents = (slots, filter = 'none') => {
         return slots.map((slot) => {
          const {start, end, duration} = slot
          const hour = moment.unix(start).format('HH')
          if(filter == 'morning' && hour >= 13) {
            return null
          }
            if(filter == 'afternoon' && hour < 13) {
            return null
          }
          const dateStart = moment.unix(start)
          const dateEnd = moment.unix(start).add(duration, 'seconds')
			 const active = selectedSlot && moment.unix(selectedSlot.start).isSame(moment.unix(slot.start), 'minute')
          const classNames = ['slot']
          if (active) {
             classNames.push('active')
          }		 
          return (
             <div key={slot.start} className={classNames.join(' ')} onClick={() => setSelectedSlot(slot)}>
                <Slot start={getHourFormat(dateStart)} end={getHourFormat(dateEnd)} slotsDurationshow={slotsDurationshow} duration={duration} />
             </div>
          )
       })
    }
    
    const getSlotsSection = (slots, filter, classNameSection) => {
      const items = getSlotsComponents(slots, filter).filter(item => item !== null)
      const translates = {
         'morning': {
            'name': 'Matin',
            'icon': 'hgi hgi-stroke hgi-sharp hgi-sunrise'
         },
         'afternoon': {
            'name': 'Après-midi',
            'icon': 'hgi hgi-stroke hgi-sun-03'
         }
      }
      if(items.length == 0) {
         return null
      }
      return (
         <div key={'slots_'+filter} className={classNameSection.join(' ')}>
            <div className={'widget_session_booking_calendar_slots_section_title'}><i className={translates[filter].icon}></i> {translates[filter].name}</div>
            <div className={'widget_session_booking_calendar_slots_section_content'}>
               {items}
            </div>
         </div>
      )
    }
    const getSlots = () => {
       const slots = _.filter(availabilities, function(o) {
          const availabilityDate = moment.unix(o.start).format('Y-MM-DD')
          return availabilityDate == selectedDate ? true : false
       })
       const classNameSection = ['widget_session_booking_calendar_slots_section']
       if (slotsDisplay == 'list') {
          classNameSection.push('widget_session_booking_calendar_slots_section__list')
       }
       if(slotsSplit){
          return (
            <>
               {getSlotsSection(slots, 'morning', classNameSection)}
               {getSlotsSection(slots, 'afternoon', classNameSection)}
            </>
         )
       } 
       const slotsSliced = slotExpand ? slots : _.slice(slots, 0, 7)
       return (
         <div className={classNameSection.join(' ')}>
            <div className={'widget_session_booking_calendar_slots_section_content'}>
               {getSlotsComponents(slotsSliced)}
            </div>
         </div>
       )

    }
 
   const getExpand = () => {
      const slots = _.filter(availabilities, function(o) {
         const availabilityDate = moment.unix(o.start).format('Y-MM-DD')
         return availabilityDate == selectedDate ? true : false
      })
      if(slotsSplit){
         return null
      }
      if(slots.length <= 7) {
         return null
      }
      if(slotExpand) {
         return (
            <button className={'btn btn-empty btn-stretch'} onClick={() => setSlotExpand(false)}>Voir moins</button>
         )
      }
      return (
         <button className={'btn btn-empty btn-stretch'} onClick={() => setSlotExpand(true)}>Voir plus</button>
      )
   }
 
   const _handleSubmit = () => {
      const dateStart = moment.unix(selectedSlot.start)
      const dateEnd = moment.unix(selectedSlot.start).add(selectedSlot.duration, 'seconds')
      const params = []
      params.push('start=' + dateStart.unix())
      params.push('end=' + dateEnd.unix())
      params.push('product=' + product.id)
      if (query) {
         params.push('query=' + query.id)
      }
      const redirect = '/expert/' + _.get(expert, 'slug') + '/checkout?' + params.join('&')
      console.log('redirect', redirect)
      window.location.href = redirect
   }
 
    const getSubmit = () => {
       if(selectedDate && selectedSlot){
          const dateStart = moment.unix(selectedSlot.start)
          return (
             <button id='booking__submit' className="btn btn-default btn-stretch" onClick={() => _handleSubmit()}>
					{t.getTranslation('calendar.submit', 'Choisir le créneau de {0}', [getHourFormat(dateStart)])}
					<i className='hgi-stroke hgi-arrow-right-02'></i>
				</button>
          )
       }
       return null
    }
 
   const getBody = () => {
      if(selectedDate){
         return (
            <div className={`${classPrefix}_body`}>
               <div className="widget_session_booking_calendar_slots">
                  {getSlots()}
                  {getExpand()}
                  {getSubmit()}
               </div>
            </div>
         )
      }
      return (
         <div className={`${classPrefix}_body`}>
            <div className={`${classPrefix}_month`}>
               {getPrevMonth()}
               {getNameMonth()}
               {getNextMonth()}
            </div>
            {getWeeks()}
          </div>
      )
   }

	const getHeaderSelectedProduct = () => {
		if(scope == 'profile') {
			return (
				<div className='widget_session_booking_calendar_selected_product'>
					<div className='widget_session_booking_calendar_selected_product_name'>{product?.name}</div>
					<ProductDetails product={product} />
				</div>
			);
		}
	}
 
    return (
      <>
		{getHeaderSelectedProduct()}
      <div className="title">{t.getTranslation('calendar.title', 'Sélectionnez une date et un créneau')}</div>
      <div className={`${classPrefix}`}>
          {getHeader()}
          {getBody()}
       </div>
      </>
    )
 
 }

export default Calendar